import type { TranslationMessages } from '../types';

export const recipes: TranslationMessages = {
  name: 'Recipe Management',
  add: 'Add Recipe',
  edit: 'Edit Recipe',
  deleteAction: 'Delete Recipe',
  create: 'Create Recipe',
  list: 'Recipes',
  search: 'Search recipes...',
  ingredients: 'Ingredients',
  status: 'Status',
  cost: 'Cost',
  valid: 'Valid',
  invalid: 'Invalid',
  empty: 'No recipes found',
  basicInformation: 'Basic Information',
  placeholders: {
    enterName: 'Enter recipe name',
    selectCategory: 'Select category',
    enterDescription: 'Enter recipe description',
    enterImageId: 'Enter image ID (optional)',
    selectIngredient: 'Select ingredient',
    enterAmount: '0',
  },
  delete: {
    title: 'Delete Recipe',
    confirm:
      'Are you sure you want to delete "%{name}"? This action cannot be undone.',
  },
  fields: {
    name: 'Name',
    description: 'Description',
    imageId: 'Image',
    productCategoryId: 'Product Category',
    ingredients: 'Ingredients',
    amount: 'Amount',
  },
  ingredient: {
    quickCreate: 'Quick create ingredient',
  },
  validation: {
    title: 'Recipe Validation Details',
    description: 'Why "%{name}" is invalid:',
    details: 'View validation details',
    noErrors: 'No validation errors found.',
    errors: 'Validation errors:',
    missingMappings: 'Missing inventory mappings:',
    missingMappingItem:
      'Ingredient "%{ingredientName}" does not have an inventory mapping. Please link this ingredient to an inventory item.',
    errorNoMapping:
      'Ingredient "%{ingredientName}" does not have an inventory mapping',
    fixInstructions:
      'To fix these issues, you can automatically create inventory items for missing ingredients, or create them manually in the inventory management page.',
    goToMappings: 'Go to Inventory Management',
    autoFix: {
      button: 'Auto-fix missing mappings',
      processing: 'Processing...',
      warning:
        'Note: Auto-fix creates basic inventory items with default settings. Package information (item count, dimensions, weight, volume) must be reviewed and configured manually by store management.',
      success:
        'Successfully created %{count} inventory items. Please review and configure package details manually.',
      error: 'Could not auto-fix: %{message}',
      partialError:
        'Created %{success} items, but %{error} items failed: %{details}',
      noWarehouse:
        'Could not auto-fix: No warehouse found. Please create a warehouse first.',
      noCategory:
        'Could not auto-fix: No inventory category found. Please create an inventory category first.',
    },
  },
};
